import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";

@Directive({
  selector: "[appOnVisible]",
  standalone: false,
})
export class OnVisibleDirective implements OnInit, OnDestroy {
  @Output() appOnVisible = new EventEmitter<void>();

  private observer: IntersectionObserver | null = null;

  public constructor(private elementRef: ElementRef) {}

  public ngOnInit(): void {
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.appOnVisible.emit();
        this.observer?.disconnect();
        this.observer = null;
      }
    });
    this.observer.observe(this.elementRef.nativeElement);
  }

  public ngOnDestroy(): void {
    this.observer?.disconnect();
    this.observer = null;
  }
}
